import { useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { Expense, ExpenseListResponse } from '@/types/settings';

export function useExpense(jobId: string, expenseId: string) {
  const queryClient = useQueryClient();
  return useQuery<Expense, Error>({
    queryKey: expenseKeys.detail(expenseId),
    queryFn: async () => {
      const cached = queryClient.getQueryData<ExpenseListResponse>(expenseKeys.byJob(jobId));
      if (cached) {
        const found = cached.data.find((e) => e.id === expenseId);
        if (found) return found;
      }
      const list = await apiGet<ExpenseListResponse>(
        operationsClient,
        expenseEndpoints.listByJob(jobId),
        { params: { limit: 50 } },
      );
      const found = list.data.find((e) => e.id === expenseId);
      if (!found) throw new Error('Expense not found');
      return found;
    },
    enabled: Boolean(jobId) && Boolean(expenseId),
  });
}
